/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iupac_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is it case sensitive?`)
};

const es_iupac_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Distingue mayúsculas y minúsculas?`)
};

const de_iupac_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird zwischen Groß- und Kleinschreibung unterschieden?`)
};

const nl_iupac_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is het hoofdlettergevoelig?`)
};

const fr_iupac_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Est-ce sensible à la casse ?`)
};

const it_iupac_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È sensibile alle maiuscole?`)
};

const pt_br2_iupac_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É sensível a maiúsculas e minúsculas?`)
};

const pt_iupac_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É sensível a maiúsculas/minúsculas?`)
};

const ja_iupac_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大文字・小文字は区別されますか？`)
};

const zh_iupac_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是否区分大小写？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iupac_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iupac_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iupac_faq_q4", locale)
	if (locale === "en") return en_iupac_faq_q4(inputs)
	if (locale === "es") return es_iupac_faq_q4(inputs)
	if (locale === "de") return de_iupac_faq_q4(inputs)
	if (locale === "nl") return nl_iupac_faq_q4(inputs)
	if (locale === "fr") return fr_iupac_faq_q4(inputs)
	if (locale === "it") return it_iupac_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_iupac_faq_q4(inputs)
	if (locale === "pt") return pt_iupac_faq_q4(inputs)
	if (locale === "ja") return ja_iupac_faq_q4(inputs)
	return zh_iupac_faq_q4(inputs)
};